<template>
  <el-dialog title="已绑设备" :visible.sync="tableShow" width="80%">
    <el-table :data="feelDevs" style="width: 100%;">
      <el-table-column :label="$store.state.module1.isChina?list.c:list.e"  v-for="(list,index) in lists" :key="index" :width="width">
        <template slot-scope="scope">
          <span class="rowSpan" v-if="index===0">{{scope.row.id}}</span>
          <span class="rowSpan" v-else-if="index===1">{{scope.row.code}}</span>
          <span class="rowSpan" v-else-if="index===2">{{scope.row.dname}}</span>
          <span class="rowSpan" v-else-if="index===3">{{scope.row.aname}}</span>
          <span class="rowSpan" v-else-if="index===4">{{scope.row.typename}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$store.state.module1.isChina?'操作':'operation'" width="200">
        <template slot-scope="scope">
           <div style="text-align: center;" class="option">
            <span style="color: #E63A3F;" @click="dobind(scope.row.code)">
              {{$store.state.module1.isChina?'解绑':'Unbound'}}
           </span>
           </div>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { stringTime, requestData } from '../../assets/js/commont.js'
export default {
  props: ['tableShow', 'width', 'feelDevs', 'proNum', 'currentP', 'fcode'],
  data () {
    return {
      lists: [
        {
          c: 'ID',
          e: 'ID'
        },
        {
          c: '识别号',
          e: 'Code'
        },
        {
          c: '设备名',
          e: 'Device name'
        },
        {
          c: '所属区域',
          e: 'Region'
        },
        {
          c: '设备类型',
          e: 'Device type'
        }
      ]
    }
  },
  methods: {
    dobind (code) {
      var data = {
        account: window.localStorage.getItem('account'),
        dcode: code,
        fcode: this.fcode,
        token: window.localStorage.getItem('token'),
        ts: stringTime(this.$myTime()),
        type: 2
      }
      this.$http.post('https://www.airdaas.com/api/xf/dobind', requestData(data)).then(res => {
        if (res.data.data === 'success') {
          this.$message({
            message: '解绑成功',
            type: 'success'
          })
          this.$emit('refresh')
        } else {
          this.$message({
            message: '解绑失败',
            type: 'warning'
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .rowSpan{
  display: inline-block;
  width:100%;
  text-align: center;
}
.option{
   span{
    cursor:pointer;
    color: #1890FF;
  }
}
</style>
